import request from '@/utils/request'

export function getAllCurrencyApi() {
  return request({
    url: '/config-service/v1/currency/all',
    method: 'get'
  })
}

export function getCurrencyListSimpleApi() {
  return request({
    url: '/config-service/v1/currency/currency',
    method: 'get'
  })
}
